export default __webpack_public_path__ + "static/media/poliapp.396c19e2.png";